import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCustomFuelIndexList extends Layout {
    layoutheaderCustomFuelIndexList: LayoutHeader;
    sourceCustomFscIndex: DataSource;
    tableCustomFuelIndex: Table;
}
